import { gsap, ScrollToPlugin, ScrollTrigger, SplitText } from 'gsap/all'
import { downArrow, header, lazyImages, pageTransitions, scrollAnimations, videoPlay } from 'components'
import hyphenation from 'utility/hyphenation'

document.addEventListener('DOMContentLoaded', (): void => {
  gsap.registerPlugin(ScrollToPlugin, ScrollTrigger, SplitText)

  header.el.root && header.init()
  lazyImages.el.images[0] && lazyImages.init()
  videoPlay.el.videoTrigger && videoPlay.init()
  
  downArrow.init()
  hyphenation.init()
  pageTransitions.init()
  scrollAnimations.init()
})
